import "./About.css";
import {ReactComponent as SubtitleFrameLightIcon} from "../../../assets/svg/text-field-dark.svg";
import {ReactComponent as SubtitleFrameDarkIcon} from "../../../assets/svg/text-field-light.svg";

export default function Hero() {
  return (
    <section className="about">
      <div className="about-left">
        <h1 className="about-title">Who we are</h1>
      </div>

      <div className="about-right">
        <p className="about-subtitle">
          <SubtitleFrameLightIcon
            className="about-subtitle-bg about-subtitle-bg-light"
            preserveAspectRatio="none"
            aria-hidden="true"
            focusable="false"
          />
          <SubtitleFrameDarkIcon
            className="about-subtitle-bg about-subtitle-bg-dark"
            preserveAspectRatio="none"
            aria-hidden="true"
            focusable="false"
          />
          Vassabi is a content provider that creates mobile entertainment services. Monetization is achieved
          through SMS subscriptions with payments made via SIM-card balance.
          <br/>
          <br/>
          In terms of traffic, we have an internal media-buying team that directs traffic to our services.
          Additionally, we act as direct advertiser for external publishers.
        </p>
      </div>

    </section>

  );
}
